var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',_vm._b({staticClass:"my-5"},'v-card',{ color: _vm.color },false),[(_vm.title)?_c('v-card-title',{domProps:{"textContent":_vm._s(_vm.title)}}):_vm._e(),_c('v-card-text',[_c('pre',[_vm._t("default")],2)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }